<template>
  <div class="pricingCard">
    <section class="headings">
      <div class="titlePrice">
        {{ title }}
      </div>
      <!-- <div class="description">
        Hellow free thing Hellow free thing Hellow free thing Hellow free thing
        Hellow free thing Hellow free thing Hellow free thing Hellow free thing
        Hellow free thing Hellow free thing
      </div> -->
    </section>
    <section>
      <div class="price">
        {{ `$ ` + price }}
      </div>
    </section>
    <section class="abc">
      <div class="offeritems">
        <div  class="offerings">
          <div class="ticksymbol">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-check"
              viewBox="0 0 16 16"
            >
              <path
                d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
              />
            </svg>

          </div>
          <div class="offer">
            {{offerings}}
          </div>
         
          
        </div>
      </div>

      
    </section>
    <section></section>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    desciption: String,
    price: Number,
    offerings: String,
  },
};
</script>

<style>
@import "./style.css";
</style>
